// It's just Emojibar, wrapped in the border we use for it as a tooltip
import React from 'react';

import Emojibar from './Emojibar';

const EmojibarPopover = ({ onEmojiSelect, onGifSelect, allowMultiSelect = true, allowCustom = true, allowGifs = true }) => (
  <div className="overflow-hidden rounded-2xl border border-white bg-gray-50 shadow-2xl dark:border-white/3 dark:bg-neutral-800/70">
    <Emojibar
      onEmojiSelect={onEmojiSelect}
      onGifSelect={onGifSelect}
      allowMultiSelect={allowMultiSelect}
      allowCustom={allowCustom}
      allowGifs={allowGifs}
    />
  </div>
);

export default EmojibarPopover;
